import React from 'react';
import './styles.scss';

const CollapsibleButton = ({ status, setStatus, title, subText, customStyling }) => {
  const customStylingForTitle = customStyling ? customStyling?.['title'] : {};
  const customStylingForSubtext = customStyling ? customStyling?.['subText'] : {};
  return (
    <div className="collapsible-details-controller">
      <div
        className="collapsible-details-container"
        onClick={() => setStatus(prevStatus => !prevStatus)}
      >
        <div className="collapsible-details-title" style={customStylingForTitle}>
          {title}
        </div>
        {subText && <div style={customStylingForSubtext}>{subText}</div>}
        <div className="collapsible-details-icon">{status ? '-' : '+'}</div>
      </div>
    </div>
  );
};

export default CollapsibleButton;
